import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "Format";
var classes = {
    card: "".concat(PREFIX, "-card"),
    loading: "".concat(PREFIX, "-loading"),
    active: "".concat(PREFIX, "-active"),
    overflow: "".concat(PREFIX, "-overflow"),
    content: "".concat(PREFIX, "-content"),
    title: "".concat(PREFIX, "-title"),
    metas: "".concat(PREFIX, "-metas"),
    hover: "".concat(PREFIX, "-hover"),
    description: "".concat(PREFIX, "-description"),
    meta: "".concat(PREFIX, "-meta"),
    metaExtenstion: "".concat(PREFIX, "-metaExtenstion")
};
var StyledFormat = styled(Box)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            position: "relative"
        },
        _b["& .".concat(classes.card)] = {
            width: theme.spacing(17),
            height: theme.spacing(25),
            borderRadius: theme.shape.borderRadius,
            position: "relative",
            border: "1px solid",
            textAlign: "left",
            "&:focus-within": {
                outline: "1px solid ".concat(theme.palette.primary.main)
            }
        },
        _b["& .".concat(classes.loading)] = {
            borderColor: theme.palette.divider
        },
        _b["& .".concat(classes.active)] = (_c = {
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16), 0px 8px 12px ".concat(alpha(theme.palette.primary.main, 0.12), ";")
            },
            _c["& .".concat(classes.title, ", & .").concat(classes.meta, ", & .").concat(classes.metas)] = {
                color: theme.palette.primary.main
            },
            _c["& .".concat(classes.metaExtenstion)] = {
                color: theme.palette.text.primary
            },
            _c),
        _b["& .".concat(classes.overflow)] = {
            height: "100%",
            width: "100%",
            overflow: "hidden",
            position: "relative"
        },
        _b["& .".concat(classes.content)] = {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            padding: theme.spacing(1)
        },
        _b["& .".concat(classes.title)] = {
            fontWeight: "bold",
            transitionDuration: "120ms",
            transitionProperty: "color",
            lineHeight: 1.2,
            wordBreak: "break-word",
            marginBottom: theme.spacing(1),
            paddingRight: theme.spacing(1),
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "6",
            WebkitBoxOrient: "vertical"
        },
        _b["& .".concat(classes.metas)] = {
            marginLeft: theme.spacing(-1),
            marginBottom: theme.spacing(-0.5),
            transitionDuration: "120ms",
            transitionProperty: "color"
        },
        _b["& .".concat(classes.hover)] = {
            transitionDuration: "120ms",
            transitionProperty: "opacity",
            position: "absolute",
            bottom: -1,
            left: -1,
            right: 0,
            width: "100%",
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.primary.main,
            paddingBottom: theme.spacing(1),
            border: "1px solid",
            borderColor: theme.palette.primary.main,
            borderRadius: theme.shape.borderRadius
        },
        _b["& .".concat(classes.description)] = {
            padding: theme.spacing(1, 1, 0, 1),
            display: "block",
            lineHeight: 1.25
        },
        _b["& .".concat(classes.meta)] = {
            fontSize: ".8rem",
            display: "inline-block",
            marginLeft: theme.spacing(1),
            marginBottom: theme.spacing(0.5),
            transitionDuration: "120ms",
            transitionProperty: "color"
        },
        _b["& .".concat(classes.metaExtenstion)] = {
            backgroundColor: theme.palette.grey[300],
            padding: theme.spacing(0.5),
            fontWeight: "bold",
            textTransform: "uppercase"
        },
        _b);
});

export { classes, StyledFormat as default };
//# sourceMappingURL=index.styled.js.map
